import Link from 'next/link';
import Pager from 'rc-pagination';
import React, { useCallback, FC } from 'react';
import { useIntl } from 'react-intl';
import { CategoryEntity } from '../../../../interfaces/explore/CategoryEntity';
import { MerchantDetail } from '../../../../interfaces/merchants';
import { MerchantBlogIndex } from '../../../../interfaces/merchants/blogs';
import Button, { ButtonSize } from '../../../../atoms/buttons/Button';
import Heading from '../../../../atoms/Heading';
import BaseTemplate from '../../../../organisms/merchants/BaseTemplate';
import MerchantProfile from '../../../../molecules/merchant/MerchantProfile';
import MerchantBlogEntries from '../../../../molecules/merchant/blogs/MerchantBlogEntries';
import css from './MerchantBlogPage.module.scss';
import { buildSiteUrl } from 'src/utils/request-url';

export interface PageProps {
  pagination: {
    totalSize: number;
    currentPage: number;
  };
  blogPosts: MerchantBlogIndex;
  publicId: string;
  merchantDetail: MerchantDetail;
  category: CategoryEntity;
  isCoubicApp: boolean;
}
type Props = PageProps;

const MerchantBlogPage: FC<Props> = ({
  blogPosts,
  merchantDetail,
  pagination: { totalSize, currentPage },
  isCoubicApp,
}) => {
  const intl = useIntl();
  const handlePageChange = useCallback((page: number) => {
    location.href = `${location.pathname}?page=${page}#pageContent`;
  }, []);

  return (
    <div className={css.MerchantBlogPage}>
      <BaseTemplate merchantDetail={merchantDetail} isCoubicApp={isCoubicApp}>
        <div className={css.MerchantBlogPage__Content}>
          <Heading className={css.MerchantBlogPage__Heading}>
            <Link
              href={buildSiteUrl(`/blogs#pageContent`, 'next')}
              prefetch={false}
              className={css.MerchantBlogPage__Link}
            >
              {intl.formatMessage({ id: 'merchants.blogs.index.title' })}
            </Link>
            {currentPage > 1 &&
              ` ${intl.formatMessage(
                { id: 'merchants.blogs.index.page' },
                { currentPage },
              )}`}
          </Heading>

          {blogPosts.data.length > 0 ? (
            <MerchantBlogEntries blogPosts={blogPosts.data} />
          ) : (
            <p className={css.MerchantBlogPage__Empty}>
              {intl.formatMessage({ id: 'merchants.blogs.noPostMessage' })}
            </p>
          )}

          <div className={css.MerchantBlogPage__Pager}>
            <Pager
              onChange={handlePageChange}
              current={currentPage}
              total={totalSize}
              showTitle={false}
            />
          </div>
          <div className={css.MerchantBlogPage__MerchantProfileSection}>
            <Heading className={css.MerchantBlogPage__Heading}>
              {intl.formatMessage(
                { id: 'merchants.details.storeData' },
                { displayName: merchantDetail.display_name },
              )}
            </Heading>
            <MerchantProfile merchantDetail={merchantDetail} />
            <div className={css.MerchantBlogPage__BackToTopButtonSection}>
              <Button
                className_Deprecated={css.MerchantBlogPage__BackToTopButton}
                isGhost={true}
                isFull={true}
                href={buildSiteUrl()}
                buttonSize={ButtonSize.Medium}
              >
                {intl.formatMessage({
                  id: 'merchants.details.backToMerchantTop',
                })}
              </Button>
            </div>
          </div>
        </div>
      </BaseTemplate>
    </div>
  );
};

export default MerchantBlogPage;
